import type { AnyAction } from 'redux';

const UPDATE = 'app/businessAddress/postcode/UPDATE';

export const actionUpdateBusinessPostcode = (value: string) => ({
  type: UPDATE,
  value,
});

export default (state: State = '', action: AnyAction) => {
  switch (action.type) {
    case UPDATE:
      return action.value;
    default:
      return state;
  }
};
